import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 1,
  class: "sc-field-value-container"
}
const _hoisted_5 = { class: "sc-field-value" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 5,
  class: "error-container"
}
const _hoisted_8 = {
  key: 0,
  class: "error"
}

import {
  reactive,
  computed,
  watchEffect,
  watch,
  ref,
  onMounted,
} from "vue";
import { Schema } from "yup";
import { Field, ErrorMessage } from "vee-validate";
import CurrencyInput from "./CurrencyInput.vue";
import { FormField, FormOption } from "@/types/form";
import { useField } from "vee-validate";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    field: {},
    schema: {},
    isSubmitting: { type: Boolean },
    isEditing: { type: Boolean },
    mode: {},
    modelValue: {},
    initialValue: {}
  },
  emits: ["update:model-value", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formData = reactive<Record<string, any>>({});

const { errors, value, errorMessage, handleChange, validate } = useField(
  props.field.name,
  props.schema
);

const isFormValid = computed(() => {
  return (errors: Partial<Record<string, string | undefined>>) =>
    errors && Object.keys(errors).length === 0;
});

function getFieldDisplayValue(value: number) {
  if (props.field.type === "select") {
    const option = props.field?.options?.find(
      (f: FormOption) => f.id === value
    );

    return option?.label || option?.name;
  }
  return null;
}

function isFieldDisabled(field: FormField) {
  const disabledOnEdit = props.mode === "edit" && field.disabledOnEdit === true;
	const disabledOnAdd = props.mode === "add" && field.disabledOnAdd === true;

  return props.mode === "view" || props.isSubmitting || disabledOnEdit || disabledOnAdd;
}

function handleFieldUpdate(
  input: number | string | null | undefined,
  event?: Event | null
) {
  emit("update:model-value", input);
}

watchEffect(() => {
  formData[props.field.name] = props.field.value;
});

watch(value, (newValue, oldValue) => {
  emit("update:model-value", newValue);
  handleChange(value.value);
});

watch(
  () => props.modelValue,
  (newValue) => {
    formData[props.field.name] = newValue;
    value.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-input-wrapper", [{ 'has-tooltip': __props.field.tooltip }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-input", [
        {
          readonly: __props.field.readonly,
          isEditing: __props.mode === 'edit' || __props.mode === 'add',
          disabled: isFieldDisabled(__props.field),
        },
      ]]),
      name: `field_${__props.field.name}`
    }, [
      (!__props.field.hideLabel)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "sc-field-label",
            for: __props.field.name
          }, [
            _createTextVNode(_toDisplayString(__props.field.label) + " ", 1),
            (__props.field.tooltip)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "sc-tooltip icon-circle-question-mark",
                  title: __props.field?.tooltipText
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      (__props.field.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(__props.field.value), 1)
            ])
          ]))
        : (__props.field.type === 'select')
          ? (_openBlock(), _createBlock(_unref(Field), {
              key: 2,
              as: "select",
              label: __props.field.label,
              name: __props.field.name,
              modelValue: _unref(value),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
              disabled: isFieldDisabled(__props.field),
              title: getFieldDisplayValue(formData[__props.field.name]),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (handleFieldUpdate(formData[__props.field.name], $event))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (emit('blur', $event)))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.id,
                    value: option.id
                  }, _toDisplayString(option?.label || option.name), 9, _hoisted_6))
                }), 128))
              ]),
              _: 1
            }, 8, ["label", "name", "modelValue", "disabled", "title"]))
          : (__props.field.type === 'money')
            ? (_openBlock(), _createBlock(CurrencyInput, {
                key: 3,
                modelValue: _unref(value),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
                name: __props.field.name,
                disabled: isFieldDisabled(__props.field),
                field: __props.field,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (handleFieldUpdate(formData[__props.field.name]))),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (emit('blur', $event)))
              }, null, 8, ["modelValue", "name", "disabled", "field"]))
            : (_openBlock(), _createBlock(_unref(Field), {
                key: 4,
                label: __props.field.label,
                id: __props.field.name,
                name: __props.field.name,
                type: __props.field.type,
                disabled: isFieldDisabled(__props.field),
                modelValue: _unref(value),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (handleFieldUpdate(formData[__props.field.name], $event))),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (emit('blur', $event)))
              }, null, 8, ["label", "id", "name", "type", "disabled", "modelValue"])),
      (__props.mode !== 'view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(ErrorMessage), {
              name: __props.field.name
            }, {
              default: _withCtx(({ message }) => [
                message
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(message), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"])
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 2))
}
}

})